import { createFileRoute } from "@tanstack/react-router";
import { MultilingualMarriageLanding } from "@/components/MultilingualMarriageLanding";
import { getMarriageLocale, MARRIAGE_HREFLANG_ALTS } from "@/data/marriage-i18n";
import { multiHreflangLinks, SEO_SITE, ctaDesc, ctaTitle } from "@/lib/seo";
import { speakableSchema, howToSchema, serviceWithReviewsSchema } from "@/lib/aeo";
import { entitySameAsSchema, softwareApplicationSchema } from "@/lib/trust-schema";

const L = getMarriageLocale("ko");

export const Route = createFileRoute("/ko/marriage")({
  head: () => ({
    meta: [
      { title: ctaTitle(L.title, "/ko/marriage", "th")},
      { name: "description", content: ctaDesc(L.description, "/ko/marriage", "th")},
      { property: "og:title", content: ctaTitle(L.title, "/ko/marriage", "th")},
      { property: "og:description", content: ctaDesc(L.description, "/ko/marriage", "th")},
      { property: "og:url", content: `${SEO_SITE}${L.path}` },
      { property: "og:locale", content: L.ogLocale },
    ],
    links: [
      { rel: "canonical", href: `${SEO_SITE}${L.path}` },
      ...multiHreflangLinks(MARRIAGE_HREFLANG_ALTS, "/marriage"),
    ],
    scripts: [
      speakableSchema(),
      howToSchema({
        name: L.h1,
        description: L.quickAnswer.a,
        inLanguage: "ko",
        totalTime: "P10D",
        estimatedCost: { currency: "THB", value: "9500" },
        steps: L.steps.map((s) => ({ name: s.name, text: s.text })),
      }),
      serviceWithReviewsSchema({
        path: L.path,
        serviceType: "International Marriage Registration Thailand",
        name: L.title,
        description: L.description,
        priceFromThb: 9500,
      }),
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "FAQPage",
          inLanguage: "ko",
          mainEntity: L.faqs.map((f) => ({
            "@type": "Question",
            name: f.q,
            acceptedAnswer: { "@type": "Answer", text: f.a },
          })),
        }),
      },
      entitySameAsSchema(),
      softwareApplicationSchema({
        url: `${SEO_SITE}/api/public/mcp`,
        name: "NYC Language Institute — MCP Server",
        description: "AI agent endpoint exposing Thailand international marriage registration tooling.",
      }),
    ],
  }),
  component: () => <MultilingualMarriageLanding l={L} />,
});
